export var paddingAttributesList = {
  padding: true,
  paddingTop: true,
  paddingBottom: true,
  paddingLeft: true,
  paddingRight: true,
  paddingX: true,
  paddingY: true
};
export var paddingAttributes = function paddingAttributes(_ref) {
  var theme = _ref.theme,
      padding = _ref.padding,
      paddingTop = _ref.paddingTop,
      paddingBottom = _ref.paddingBottom,
      paddingLeft = _ref.paddingLeft,
      paddingRight = _ref.paddingRight,
      paddingY = _ref.paddingY,
      paddingX = _ref.paddingX;
  var result = '';

  if (typeof padding !== 'undefined') {
    result += "padding: ".concat(theme.spacing(padding), ";");
  }

  if (typeof paddingTop !== 'undefined') {
    result += "padding-top: ".concat(theme.spacing(paddingTop), ";");
  }

  if (typeof paddingBottom !== 'undefined') {
    result += "padding-bottom: ".concat(theme.spacing(paddingBottom), ";");
  }

  if (typeof paddingLeft !== 'undefined') {
    result += "padding-left: ".concat(theme.spacing(paddingLeft), ";");
  }

  if (typeof paddingRight !== 'undefined') {
    result += "padding-right: ".concat(theme.spacing(paddingRight), ";");
  }

  if (typeof paddingX !== 'undefined') {
    var value = theme.spacing(paddingX);
    result += "padding-right: ".concat(value, "; padding-left: ").concat(value, ";");
  }

  if (typeof paddingY !== 'undefined') {
    var _value = theme.spacing(paddingY);

    result += "padding-top: ".concat(_value, "; padding-bottom: ").concat(_value, ";");
  }

  return result;
};